const PublishedCampaigns = () =>
  import(/* webpackChunkName: 'PublishedCampaigns' */ '@/Campaigns/components/PublishedCampaigns');
const PublishedCampaignPreview = () =>
  import(
    /* webpackChunkName: 'PublishedCampaignPreview' */ '@/Campaigns/components/PublishedCampaignPreview'
  );
const Templates = () =>
  import(/* webpackChunkName: 'Templates' */ '@/Campaigns/components/Templates');
const CampaignsIndex = () => import(/* webpackChunkName: 'CampaignsIndex' */ '@/Campaigns/Index');
const CampaignsShow = () => import(/* webpackChunkName: 'CampaignsShow' */ '@/Campaigns/Show');
const ActionsCreate = () => import(/* webpackChunkName: 'ActionsCreate' */ '@/Campaigns/Create');
const ActionsEdit = () => import(/* webpackChunkName: 'ActionsEdit' */ '@/Campaigns/Edit');
const LandingPages = () =>
  import(/* webpackChunkNamE: 'LandingPages' */ '@/Campaigns/components/LandingPages');

export default [
  {
    path: '/campaigns',
    name: 'campaigns',
    component: CampaignsIndex,
    meta: { auth: true, howToVideoFeature: 'campaigns' },
  },
  {
    path: '/campaigns/:id/actions/create',
    name: 'actions-create',
    component: ActionsCreate,
    props: true,
    meta: { auth: true },
  },
  {
    path: '/campaigns/:id',
    name: 'campaigns-show',
    component: CampaignsShow,
    props: true,
    meta: { auth: true, howToVideoFeature: 'campaigns' },
  },
  {
    path: '/campaigns/:id/actions/:actionId/edit',
    name: 'actions-edit',
    component: ActionsEdit,
    props: true,
    meta: { auth: true },
  },
  {
    path: '/published-campaigns/:id/preview',
    name: 'preview-published-campaign',
    component: PublishedCampaignPreview,
    props: true,
    meta: { auth: true },
  },
  {
    path: '/published-campaigns',
    name: 'published-campaigns',
    component: PublishedCampaigns,
    props: true,
    meta: { auth: true, howToVideoFeature: 'published campaigns' },
  },
  {
    path: '/templates',
    name: 'templates',
    component: Templates,
    meta: { auth: true, howToVideoFeature: 'templates' },
  },
  {
    path: '/landing-pages',
    name: 'landing-pages',
    component: LandingPages,
    meta: { auth: true },
  },
];
